
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { logError } from '../Utils/loggers';

import { jwtDecode } from "jwt-decode"; 


export const fetchToken = async (instance, loginRequest, accounts) => {
  try {
    const tokenResponse = await instance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0],
    });

    const decodedToken = jwtDecode(tokenResponse.accessToken);
    const currentTime = Math.floor(Date.now() / 1000); // current time in seconds


    if (decodedToken.exp <= currentTime) {
      logError("fetchToken", "expired token detected");
      throw new Error("Access token is expired");
  
    }

    return tokenResponse;
  } catch (error) {
    console.error("TOKEN ERROR IN TOKEN REQUEST ", error);
    if (error instanceof InteractionRequiredAuthError) {
      return await instance.acquireTokenPopup(loginRequest);
      logError("fetchToken", "error in fetching token, interaction required", error)
      // return { sessionExpired: true };
    }
    logError("fetchToken", "error in fetching token", error)
    throw error;
  }
};